import React, { Suspense } from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import reportWebVitals from './reportWebVitals';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';

// Chargement différé du composant App
const App = React.lazy(() => import('./App'));

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <Suspense fallback={
      <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
        <div className="loading-spinner"></div>
      </div>
    }>
      <App />
    </Suspense>
  </React.StrictMode>
);

// Détecter si nous sommes dans un environnement mobile (Capacitor)
const isMobileApp = () => {
  return window.location.protocol.includes('capacitor') || 
         document.URL.includes('capacitor://') ||
         document.URL.includes('localhost/');
};

// Enregistrer le service worker uniquement en environnement web
if ('serviceWorker' in navigator && !isMobileApp()) {
  // Utiliser le service worker standard
  serviceWorkerRegistration.register();
} else if ('serviceWorker' in navigator && isMobileApp()) {
  // En environnement mobile, désactiver/désinscrire les service workers existants
  navigator.serviceWorker.getRegistrations().then(registrations => {
    for (let registration of registrations) {
      registration.unregister();
    }
  });
}

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
